import { I18nData } from './ja';

// eslint-disable-next-line no-undef
const define: RecursivePartial<I18nData> = {
  app: {
    name: 'Hoshino Resorts [Official]',
  },
  name: {
    site: 'Hoshino Resorts Official Website | Hotels & Resorts',
    hr: 'Hoshino Resorts',
    hrGiftTicket: 'Hoshino Resorts Coupons (Japanese version only)',
    vacancySearch: 'Check Availability',
    vacancySearchShort: 'Availability',
    roomFinder: 'Hoshino Resorts Room Finder',
    access: 'Maps and directions',
    contact: 'Contact',
    specialPageList: 'Travel Articles',
  },
  language: {
    ja: 'Japanese',
    en: 'English',
    ko: 'Korean',
    zh_cn: 'Chinese (Simplified)',
    zh_tw: 'Chinese (Traditional)',
  },
  label: {
    viewOffers: 'View offers',
    localeMap: 'Google maps',
    transportInformation: 'Directions',
    todo: 'Itinerary',
    todoKai: 'Itinerary',
    notice: 'Notices',
    reservation: 'Reservation',
    month: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    dayOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    yearMonth:
      '<span class="i18n-label-yearMonth__month">{month}</span><span class="i18n-label-yearMonth__year">{year}</span>',
    beds: 'Beds',
    guestRooms: 'Guest Rooms',
    facilitiesAndAmenities: 'Room Amenities',
    restaurant: 'Restaurant',
    cafeAndLounge: 'Café / Lounge',
    spaAndMassage: 'Spa / Massage',
    playroom: 'Playroom',
    pool: 'Pool',
    onsen: 'Onsen',
    publicBath: 'Public bath',
    meetingRoom: 'Meeting Room',
    parking: 'Parking',
    evCharger: 'EV charging',
    wifi: 'Wi-Fi',
    wedding: 'Weddings',
    waterSection: 'Bathroom',
    accessibility: 'Accessibility',
    shuttleService: 'Shuttle service',
    petsAccepted: 'Pets',
    pets: 'Pets',
    childrenAndBeds: 'Bed share',
    checkInOut: 'Check-in / Check-out',
    roomOccupancy: 'Room Occupancy',
    onlinePayments: 'Online Payments',
    onsitePayments: 'Onsite Payments',
    cash: 'Cash',
    cashNotPossibleCaution: `※ No Cash Accepted`,
    lightOffTime: 'Lights-out',
    luggageStorage: 'Lockers',
    waterService: 'Water dispenser',
    businessPeriod: 'Open season',
    generalMemo: 'General',
    mainFacilities: 'Facilities',
    displayCurrency: 'Currency',
    pressCenter: 'Press Center',
    recruitInfo: 'Career: JA ver.',
    REITIntro: 'For Investors',
    dynamicPacage: {
      air: 'Book Flight + Hotel',
      airMin: '+ Flight',
      shinkansen: 'Book Train + Hotel',
      rentalCar: 'Rental Car + Hotel',
    },
    currencyDisplay: 'Change Currency',
    hours: 'Hours',
    openHours: 'Open',
    twentyFourhours: '24 Hours',
    details: 'Details',
    moreInformation: 'Information',
    emergencyAtNight: 'Emergency',
    specialArrangements: 'Special Arrangements',
    reservationCenter: 'Reservations',
    hotelLowestPricePrefix: '1 Night 1 Guest',
    guestSuffix: ' / guest',
    activity: 'Activity',
    activities: 'Activities',
    period: 'Period',
    holdingPeriod: 'Availability',
    price: 'Price',
    timeRequired: 'Duration',
    timeToHold: 'Time',
    meetingSpot: 'Meeting spot',
    applicationDeadline: 'Reservation',
    peopleQuota: 'Capacity',
    belongings: 'Belongings',
    includedContent: 'Contents',
    notes: 'Notes',
    schedule: 'Schedule',
    type: 'Type',
    diningStyle: 'Menu',
    kids: 'Kids',
    averageBudget: 'Average price',
    noReservationRequired: 'No reservation required',
    restaurantHours: 'Hours',
    all: 'All',
    appropriateAge: 'Appropriate age',
    allYear: 'All year',
    hostLanguage: 'Hosted in',
    enMaps: 'Maps',
    necessary: 'Required',
    unnecessary: 'Not Required',
    busStop: 'Pick up point',
    transfarBusStop: 'Pick up point',
    forAllAges: 'For all ages',
    parentAndChild: 'Family with kids',
    jpAdult: 'For adults (Age 20 and up)',
    email: 'Email',
    password: 'Password',
    reservationDeadline: 'Reservation',
    boarding: 'Pick Up Point',
    skiing: 'Ski',
    privacyPolicy: 'Privacy Policy',
    specialCommercialLaw: '',
    hotelSite: 'Website',
    exampleAccommodationFee: 'Example accommodation fee',
    pageTopShort: 'Home',
    information: 'Information',
    keyword: 'Keyword',
    companyAnniversary: '{year}YEARS',
    address: 'Address',
    help: 'How can we help?',
    faq: 'FAQ',
    chat: 'Chat',
    phone: 'Phone',
    story: 'Stories',
    termsOfuse: 'Terms Of Use',
    open: 'Open',
    signIn: 'Sign In・My Stays',
    settings: 'Settings',
    chatNow: 'Chat Now!',
    published: 'Published',
    viewAllBrand: 'View All',
    travelArticles: 'Travel Articles',
    brands: {
      categories: {
        hoshinoya: 'Luxury hotel',
        kai: 'Onsen Ryokan',
        risonare: 'Resort hotel',
        omo: 'City Hub hotel',
        beb: 'Unbound Stay',
      },
    },
    listOfHotels: `Properties`,
    brand: 'Brands',
    searchResult: 'Search results',
    filters: 'Filters',
    specialPage: 'Travel Article',
    footer: {
      total: 'Total {count} Properties',
      showLess: 'Show less',
      exploreOurDestinations: 'Explore Our Destinations',
      brands: 'Brands',
      regions: 'Regions',
    },
    regions: {
      hokkaido: 'Hokkaido',
      tohoku: 'Tohoku',
      hokurikuKoushinetsu: 'Hokuriku, Koshinetsu',
      kanto: 'Kanto',
      tokai: 'Tokai',
      kinki: 'Kinki',
      chugokuShikoku: 'Chugoku, Shikoku',
      kyushu: 'Kyushu',
      okinawa: 'Okinawa',
      overseas: 'Outside Japan',
    },
  },
  vacancyCalendar: {
    available: 'Available',
    fewLeft: 'Few left',
    cannotArrive: 'No check-in',
    closed: 'closed',
  },
  action: {
    ok: 'OK',
    cancel: 'CANCEL',
    viewTimeTable: 'See time table',
    enlargePhoto: 'Enlarge the photo',
    close: 'Less', // @TBD
    closeDetails: 'Less',
    viewNearbySpotsAslist: 'View as list',
    closeNearbySpots: 'Close list',
    closeList: 'Close list',
    gotoReserveThisRoom: 'Reserve this room',
    viewMoreRoomData: 'More',
    closeRoomData: 'Less',
    confirmMyReservation: 'My Reservations',
    gotoBookARoom: 'Book a room',
    reserveActivity: 'Reserve the activity',
    reserve: 'Reserve',
    vacantSeatConfirmation: 'Chack availability/Reservation',
    vacantSeatConfirmationShort: 'Reserve',
    backToList: '{listName}',
    viewActivityDetail: 'More',
    viewDinnerDetail: 'More',
    login: 'Sign in',
    loginRememberMe: 'Remember me.',
    accountRegister: 'Hoshino Resorts Customer Account Registration',
    reset: 'Reset',
    filters: 'Filters',
    contact: 'Contact',
    closeMenu: 'Close menu',
    contactInformation: 'Contact Information',
    exploreMore: 'Explore more',
    forFullList: 'For Full List',
    hoshinoResortsTop: 'Hoshino Resorts HOME',
    closeNotice: 'Close Notices',
  },
  guide: {
    isLowestRatePerPersonOnFirstNight:
      'Displayed rate is lowest rate per person on first night, based on indicated number of guests and nights.',
    taxShort: 'Taxes excluded',
    taxLong: 'Taxes and Charges are excluded.',
    bestRateShort: 'Best Rate Guaranteed',
    bestRate: 'Best Rate Guaranteed.',
    switchDisplayLanguage: 'Switch the display language',
    switchDisplayCurrency: 'Switch the display currency',
    freeWifi: 'Available in all rooms and in some public areas: Free Wi-Fi',
    needReservationLogin: `Log in to the "Confirmation" page is required.`,
    allergy: `Response regarding food allergies`,
    passwordReminder: 'Forgot Password?',
    loginToHRAccount: 'Sign in to your Hoshino Resorts Account',
    tourBuilderPopup:
      'Please enter your travel information for flight tickets.',
    // @memo 後ほど確認
    confirmDisplayLanguage:
      'Would you like to display in the same language as the web language settings',
  },
  notice: {
    petsNotAllowed: 'Not Allowed',
  },
  validation: {},
  value: {
    address: '{address} {postcode}',
    viewPhotos: 'View {count} Photos',
    numOfGuests: '{n}',
    politeNumOfGuests: '{n} Guest | {n} Guest | {n} Guests',
    guestsRange: '{guestsRange} Guests',
    personsRange: '{personsRange} Persons',
    numOfAdults: '{n} Adult | {n} Adult | {n} Adults',
    numOfChildren: '{n} Child | {n} Child | {n} Children',
    numOfRooms: '{n} Room | {n} Room | {n} Rooms',
    numOfBuildings: '{n} building | {n} building |{n} buildings',
    nights: '{n} Night | {n} Night | {n} Nights',
    seeMorephotosByCount: 'see more {count} photos',
    dailyLabel: 'Day {n}',
    viewAt: `View {target}`,
    resultCount:
      '<span>{n}</span> Result | <span>{n}</span> Result | <span>{n}</span> Results',
    aroundMinutes: 'Around {n} minutes',
    yearsRange: '{from} - {to} years old',
    yearsLessThan: '{to} years and under',
    yearsGreaterThan: '{from} years or older',
    hotelOpen: '{date} OPEN',
    hotelSoftOpen: '{date} SOFT OPEN',
    // hotelRenewalOpen: '{date} Reopen',
    hotelMetaTitle: `{fullName} - Official Site`,
    timeRequired: {
      minutes: '{minutes} minutes',
      anHour: '{hours} hour',
      hours: '{hours} hours',
      anHourAndMinutes: '{hours} hour and {minutes} minutes',
      hoursAndMinutes: '{hours} hours and {minutes} minutes',
    },
    nightsAndDays: '{nights}Night (s) {days}day (s)',
    nightAndGuests: '1 Night {perGuest} Guest',
    pageHomeWithName: '{name} Home',
    numOfHotels: `Total <span>{count}</span> Properties`,
  },
  url: {
    globalTop: 'https://hoshinoresorts.com/en/',
    REIT: 'https://www.hoshinoresorts-reit.com/en/',
    allergy: 'https://hoshinoresorts.com/en/sp/allergy/',
    specialCommercialLaw: '',
    pressCenter: 'https://hoshinoresorts.com/en/presscenter/',
    termsOfuse: 'https://hoshinoresorts.com/en/sp/termsofuse/',
    legalNoticeAccommodations:
      'https://hoshinoresorts.com/en/sp/accomodationcontract/',
    recruit: 'https://hoshinoresorts.com/jp/recruit/',
    privacyPolicy: 'https://hoshinoresorts.com/en/sp/privacypolicy/',
  },
  plan: {
    mealType: {
      'one-meal': 'Breakfast Included',
      'two-meals': 'Dinner and Breakfast Included',
      'without-meals': 'Room Rate',
    },
  },
  chore: {
    dash: '–',
    marginDash: ' – ',
    space: ' ',
    wordSparator: ', ',
    notAvailable: 'Not Available',
    exist: 'Available',
    notExist: 'Not Available',
    contact: 'Inquiries',
    allowed: 'Allowed',
    notAllowed: 'Not Allowed',
    notAccepted: 'Not Accepted',
    approximatelyPrefix: 'Around ',
    pricePerMonth: '',
  },
  validates: {
    email: {
      required:
        'The email field is blank.This information is required. Please complete these fields.',
      pattern: 'please type a valid email address.',
    },
    password: {
      required: 'Please enter your password',
    },
  },
  locationMaps: {
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    touchDevicePanMap: 'Use two fingers to move the map',
    scaleMetaKey: 'Control key',
    scaleMetaKeyForMac: 'command key',
    zoomGuide: 'To zoom in on the map, hold down the {metaKey} and scroll.',
    seeMore: 'Details',
  },
  /** @memo Paidyは2024年1月現在日本だけ対応しているので多言語対応はしていない */
  paidy: {
    whatIsPaidy: '',
    paidy: '',
  },
  error: {
    descriptions: {
      '401': 'Login is required.',
      '404': 'The requested URL was not found.',
      '500': 'Please try again later.',
      '503': 'Please try again later.',
      '504': 'Please try again later.',
      UnAuthorized: 'Please double-check your ID and Password and try again.',
    },
    homeUrl: 'https://hoshinoresorts.com/en/',
    toHome: `Hoshino Resorts HOME`,
  },
  // 全文検索
  search: {
    types: {
      hotels: 'Hotel Site',
      brands: 'Brand Site',
    },
    placeholder: 'Destination',
  },
};

export default define;
